import { tsValidateValue } from '@nu-art/ts-common';
import { EpicKeyRings } from './types.js';
export const Validator_EpicKeyRing = tsValidateValue(EpicKeyRings);
//# sourceMappingURL=validator.js.map